export enum TipoToasta {
    ERROR       = 1,
    INFORMATIVO = 2,
    EXITO       = 3,
    ADVERTENCIA = 4,
    DEFAULT     = 5,
    ESPERA      = 6,
}